(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curated-new-edit"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('curated-product-rail')) {

  class CuratedProductRail extends HTMLElement {

    connectedCallback() {

      this.rail =
        this.querySelector(
          '[data-product-rail]'
        );

      this.cards =
        Array.from(
          this.querySelectorAll(
            '[data-product-card]'
          )
        );

      this.previousButton =
        this.querySelector(
          '[data-rail-previous]'
        );

      this.nextButton =
        this.querySelector(
          '[data-rail-next]'
        );

      this.navigation =
        this.querySelector(
          '[data-rail-navigation]'
        );


      if (
        !this.rail ||
        this.cards.length === 0
      ) {

        this.hideNavigation();

        return;

      }


      this.abortController =
        new AbortController();

      const { signal } =
        this.abortController;


      this.previousButton?.addEventListener(
        'click',
        () => this.move(-1),
        { signal }
      );


      this.nextButton?.addEventListener(
        'click',
        () => this.move(1),
        { signal }
      );


      this.rail.addEventListener(
        'scroll',
        () => this.queueUpdate(),
        {
          passive: true,
          signal
        }
      );


      if ('ResizeObserver' in window) {

        this.resizeObserver =
          new ResizeObserver(
            () => this.updateControls()
          );


        this.resizeObserver.observe(
          this.rail
        );

      }


      this.updateControls();

    }



    disconnectedCallback() {

      this.abortController?.abort();

      this.resizeObserver?.disconnect();


      if (this.animationFrame) {

        cancelAnimationFrame(
          this.animationFrame
        );

      }

    }



    hideNavigation() {

      if (this.navigation) {

        this.navigation.hidden = true;

      }

    }



    prefersReducedMotion() {

      return window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

    }



    getCurrentIndex() {

      if (
        !this.rail ||
        !this.cards.length
      ) {
        return 0;
      }


      const railRect =
        this.rail.getBoundingClientRect();


      const rtl =
        getComputedStyle(
          this.rail
        ).direction === 'rtl';


      const railStart =
        rtl
          ? railRect.right
          : railRect.left;


      let closestIndex = 0;

      let closestDistance =
        Number.POSITIVE_INFINITY;


      this.cards.forEach(
        (card, index) => {

          const cardRect =
            card.getBoundingClientRect();


          const cardStart =
            rtl
              ? cardRect.right
              : cardRect.left;


          const distance =
            Math.abs(
              cardStart - railStart
            );


          if (
            distance <
            closestDistance
          ) {

            closestDistance =
              distance;

            closestIndex =
              index;

          }

        }
      );


      return closestIndex;

    }



    move(direction) {

      const currentIndex =
        this.getCurrentIndex();


      const targetIndex =
        Math.max(
          0,
          Math.min(
            this.cards.length - 1,
            currentIndex + direction
          )
        );


      const targetCard =
        this.cards[targetIndex];


      if (!targetCard) {
        return;
      }


      targetCard.scrollIntoView({

        behavior:
          this.prefersReducedMotion()
            ? 'auto'
            : 'smooth',

        block: 'nearest',
        inline: 'start'

      });

    }



    queueUpdate() {

      if (this.animationFrame) {

        cancelAnimationFrame(
          this.animationFrame
        );

      }


      this.animationFrame =
        requestAnimationFrame(
          () => this.updateControls()
        );

    }



    updateControls() {

      if (!this.rail) {
        return;
      }


      const hasOverflow =
        this.rail.scrollWidth >
        this.rail.clientWidth + 2;


      if (this.navigation) {

        this.navigation.hidden =
          !hasOverflow;

      }


      if (!hasOverflow) {

        if (this.previousButton) {
          this.previousButton.disabled = true;
        }

        if (this.nextButton) {
          this.nextButton.disabled = true;
        }

        return;

      }


      const index =
        this.getCurrentIndex();


      if (this.previousButton) {

        this.previousButton.disabled =
          index <= 0;

      }


      if (this.nextButton) {

        this.nextButton.disabled =
          index >=
          this.cards.length - 1;

      }

    }

  }


  customElements.define(
    'curated-product-rail',
    CuratedProductRail
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["occasion-edit"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('brand-occasion-grid')) {

    class BrandOccasionGrid extends HTMLElement {

      connectedCallback() {

        this.scroller =
          this.querySelector(
            '[data-occasion-scroller]'
          );

        this.cards =
          Array.from(
            this.querySelectorAll(
              '[data-occasion-card]'
            )
          );

        this.previousButton =
          this.querySelector(
            '[data-occasion-previous]'
          );

        this.nextButton =
          this.querySelector(
            '[data-occasion-next]'
          );


        if (
          !this.scroller ||
          this.cards.length === 0
        ) {
          return;
        }


        this.abortController =
          new AbortController();

        const { signal } =
          this.abortController;


        this.previousButton?.addEventListener(
          'click',
          () => this.goToRelativeCard(-1),
          { signal }
        );


        this.nextButton?.addEventListener(
          'click',
          () => this.goToRelativeCard(1),
          { signal }
        );


        this.scroller.addEventListener(
          'scroll',
          () => this.queueControlsUpdate(),
          {
            passive: true,
            signal
          }
        );


        /*
          Shopify Theme Editor:
          when a block is selected on mobile,
          bring the matching card into view.
        */

        this.addEventListener(
          'shopify:block:select',
          (event) => {

            if (
              !window.matchMedia(
                '(max-width: 749px)'
              ).matches
            ) {
              return;
            }


            const selectedCard =
              event.target.closest?.(
                '[data-occasion-card]'
              );


            if (!selectedCard) {
              return;
            }


            selectedCard.scrollIntoView({

              behavior:
                this.prefersReducedMotion()
                  ? 'auto'
                  : 'smooth',

              block: 'nearest',
              inline: 'start'

            });

          },
          { signal }
        );


        if ('ResizeObserver' in window) {

          this.resizeObserver =
            new ResizeObserver(
              () => this.updateControls()
            );


          this.resizeObserver.observe(
            this.scroller
          );

        }


        this.updateControls();

      }



      disconnectedCallback() {

        this.abortController?.abort();

        this.resizeObserver?.disconnect();


        if (this.animationFrame) {

          cancelAnimationFrame(
            this.animationFrame
          );

        }

      }



      prefersReducedMotion() {

        return window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

      }



      getCurrentCardIndex() {

        if (
          !this.scroller ||
          this.cards.length === 0
        ) {
          return 0;
        }


        const scrollerRect =
          this.scroller.getBoundingClientRect();


        const isRTL =
          getComputedStyle(
            this.scroller
          ).direction === 'rtl';


        const scrollerStart =
          isRTL
            ? scrollerRect.right
            : scrollerRect.left;


        let closestIndex = 0;

        let closestDistance =
          Number.POSITIVE_INFINITY;


        this.cards.forEach(
          (card, index) => {

            const cardRect =
              card.getBoundingClientRect();


            const cardStart =
              isRTL
                ? cardRect.right
                : cardRect.left;


            const distance =
              Math.abs(
                cardStart - scrollerStart
              );


            if (
              distance < closestDistance
            ) {

              closestDistance =
                distance;

              closestIndex =
                index;

            }

          }
        );


        return closestIndex;

      }



      goToRelativeCard(direction) {

        if (
          !window.matchMedia(
            '(max-width: 749px)'
          ).matches
        ) {
          return;
        }


        const currentIndex =
          this.getCurrentCardIndex();


        const targetIndex =
          Math.max(
            0,
            Math.min(
              this.cards.length - 1,
              currentIndex + direction
            )
          );


        const targetCard =
          this.cards[targetIndex];


        if (!targetCard) {
          return;
        }


        targetCard.scrollIntoView({

          behavior:
            this.prefersReducedMotion()
              ? 'auto'
              : 'smooth',

          block: 'nearest',
          inline: 'start'

        });

      }



      queueControlsUpdate() {

        if (this.animationFrame) {

          cancelAnimationFrame(
            this.animationFrame
          );

        }


        this.animationFrame =
          requestAnimationFrame(
            () => this.updateControls()
          );

      }



      updateControls() {

        if (
          !this.previousButton &&
          !this.nextButton
        ) {
          return;
        }


        const hasOverflow =
          this.scroller.scrollWidth >
          this.scroller.clientWidth + 2;


        if (!hasOverflow) {

          if (this.previousButton) {
            this.previousButton.disabled = true;
          }


          if (this.nextButton) {
            this.nextButton.disabled = true;
          }


          return;

        }


        const currentIndex =
          this.getCurrentCardIndex();


        if (this.previousButton) {

          this.previousButton.disabled =
            currentIndex <= 0;

        }


        if (this.nextButton) {

          this.nextButton.disabled =
            currentIndex >=
            this.cards.length - 1;

        }

      }

    }


    customElements.define(
      'brand-occasion-grid',
      BrandOccasionGrid
    );

  }


  } catch(e) { console.error(e); }
})();
})();
